import React from 'react';
import { Box as RebassBox } from 'rebass';

const Box = props => <RebassBox {...props} />;

export default Box;
